import React from 'react';
import Header from './Header';
import Footer from './Footer';
import MobileAppDownload from './MobileAppDownload';

const Layout = ({ children }) => {
  return (
    <div className="layoutWrapper">
      <Header />
         <main className="content">{children}</main>
      <Footer />
      <MobileAppDownload />
    </div>
  );
};

export default Layout;
